<app-flow-action-card icon="sms" iconColor="text-amber-600" label="SMS notificatie">
  <span class="break-words" [innerHTML]="data().value.message | highlightVariables"></span>

  <mat-divider class="my-4! [--mat-divider-color:var(--color-gray-200)]" />

  <div>
    <div class="font-medium">Ontvangers:</div>
    <div class="flex flex-wrap gap-1 mt-1">
      @for (recipient of data().value.recipients; track recipient._id) {
        <div class="bg-gray-300 text-gray-800 py-0.5 px-1 rounded-sm text-xs font-medium">
          {{ recipient.name }}
        </div>
      } @empty {
        <span class="text-xs text-gray-800">Er zijn geen ontvangers</span>
      }
    </div>
  </div>
</app-flow-action-card>
